import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-help-dialog',
  templateUrl: './helpDialog.component.html',
  styleUrls: ['./helpDialog.component.scss'],
  standalone: true,
  imports: [MatButtonModule, MatDialogModule],
})
export class HelpDialogComponent {
  public version = environment.version;

  orgs = [
    {
      name: 'EuroVolc',
      sources: [{ name: 'EuroVolc', url: 'https://eurovolc.eu/' }],
    },
    {
      name: 'Icelandic Met Office - SO2_IMO',
      sources: [{ name: 'Icelandic Met Office - SO2_IMO', url: 'https://www.vedur.is/skraning_brennisteinsmengun/' }],
    },
    {
      name: 'INGV',
      sources: [
        { name: 'INGV', url: 'http://www.ingv.it/it/' },
        { name: 'INGV-OE (Etna Observatory)', url: 'http://www.ct.ingv.it/' },
        {
          name: 'VONA (Volcano Observatory Notice for Aviation)',
          url: 'http://www.ct.ingv.it/index.php/monitoraggio-e-sorveglianza/prodotti-del-monitoraggio/comunicati-vona',
        },
      ],
    },
    {
      name: 'British Geological Survey',
      sources: [{ name: 'myVolcano', url: 'https://www.bgs.ac.uk/myVolcano/' }],
    },
    {
      name: 'Volcano information',
      sources: [
        { name: 'Icelandic Catalogue of Volcanoes', url: 'http://futurevolc.vedur.is/' },
        { name: 'European Catalogue of Volcanoes', url: 'http://icelandicvolcanoes.is/eurovolc/' },
        { name: 'Smithsonian Institution Global Volcanism Program', url: 'https://volcano.si.edu/' },
      ],
    },
  ];
}
